<template>
  <UnifiedBar
    :show-nav-toggle="showNavToggle"
    @toggle-drawer="$emit('toggle-drawer')"
  />
</template>

<script>
import UnifiedBar from "./components/UnifiedBar/UnifiedBar.vue";

export default {
  components: { UnifiedBar },
  props: {
    showNavToggle: {
      type: Boolean,
      default: false
    }
  },
  created() {}
};
</script>

<style></style>
